import api from './api';

const testConfigurationService = {
  // Get all test configurations
  getAll: async () => {
    try {
      const response = await api.get('/api/super-admin/test-configurations');
      return response.data;
    } catch (error) {
      console.error('Error fetching test configurations:', error);
      throw error;
    }
  },

  // Get test configuration by ID
  getById: async (id) => {
    try {
      const response = await api.get(`/api/super-admin/test-configurations/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching test configuration:', error);
      throw error;
    }
  },

  // Update test configuration status (activate/deactivate)
  updateStatus: async (id, isActive) => {
    try {
      const response = await api.patch(`/api/super-admin/test-configurations/${id}/status`, { isActive });
      return response.data;
    } catch (error) {
      console.error('Error updating test configuration status:', error);
      throw error;
    }
  },

  // Update test configuration status for specific tenant
  updateTenantStatus: async (id, tenantId, isActive) => {
    try {
      const response = await api.patch(`/api/super-admin/test-configurations/${id}/tenant/${tenantId}/status`, { isActive });
      return response.data;
    } catch (error) {
      console.error('Error updating tenant-specific test configuration status:', error);
      throw error;
    }
  },

  // Create new test configuration
  create: async (configData) => {
    try {
      const response = await api.post('/api/super-admin/test-configurations', configData);
      return response.data;
    } catch (error) {
      console.error('Error creating test configuration:', error);
      throw error;
    }
  },

  // Update test configuration
  update: async (id, configData) => {
    try {
      const response = await api.put(`/api/super-admin/test-configurations/${id}`, configData);
      return response.data;
    } catch (error) {
      console.error('Error updating test configuration:', error);
      throw error;
    }
  },

  // Delete test configuration
  delete: async (id) => {
    try {
      await api.delete(`/api/super-admin/test-configurations/${id}`);
    } catch (error) {
      console.error('Error deleting test configuration:', error);
      throw error;
    }
  },

  // Get test configuration statistics
  getStats: async () => {
    try {
      const response = await api.get('/api/super-admin/test-configurations/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching test configuration stats:', error);
      throw error;
    }
  },

  // Validate question availability for a configuration
  validateQuestionAvailability: async (configId) => {
    try {
      const response = await api.post(`/api/super-admin/test-configurations/${configId}/validate`);
      return response.data;
    } catch (error) {
      console.error('Error validating question availability:', error);
      throw error;
    }
  }
};

export default testConfigurationService;
